
import httpClient from './httpClient';

const prefix = 'core'

export default {
  async get_billable_bookings(page, perPage) {
    const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/billings?page=${page}&perPage=${perPage}`);
    
    return data;
  },
  async get_waiting_for_billing(page, perPage) {
    const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/wait-billings?page=${page}&perPage=${perPage}`);
    
    return data;
  }, 
  async get_billings(page, perPage) {
    const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/billings/all?page=${page}&perPage=${perPage}`);
    
    return data;
  },
  async get_export_billings(billingNo) {
    const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/export-billings/${billingNo}`);
    
    return data;
  },
  async get_export_sub_billings(billingNo) {
    const {data} = await httpClient({ requiresAuth: true }).get(`${prefix}/export-billings-sub/${billingNo}`);
    
    return data;
  },
  async create_billing(billing) {
    const {data} = await httpClient({ requiresAuth: true }).post(`${prefix}/billings`, billing);
    
    return data;
  },
  async create_billing_list(billings) {
    const {data} = await httpClient({ requiresAuth: true }).post(`${prefix}/multi_billings`, billings);
    
    return data;
  }
}